<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M11.38 8.87A3.388 3.388 0 0 0 8 12.25v8.915c0 .46.376.835.835.835.459 0 .834-.376.834-.835V12.25c0-.943.768-1.71 1.712-1.71h.233V8.87h-.233ZM13.5 8.87h-.225v1.67h.226c.943 0 1.711.767 1.711 1.71v8.915c0 .46.376.835.835.835.459 0 .834-.376.834-.835V12.25c0-1.861-1.519-3.38-3.38-3.38Z"
    />
    <path d="M11.606 2v8.723c0 .459.376.835.835.835.459 0 .834-.376.834-.835V2h-1.669Z" />
  </svg>
</template>

<script>
export default {};
</script>
